import { render, staticRenderFns } from "./RefundBoletoConfirmation.vue?vue&type=template&id=085d2fe0&"
import script from "./RefundBoletoConfirmation.vue?vue&type=script&lang=js&"
export * from "./RefundBoletoConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports